import { withInstall } from '../../utils/install';
import Progress from './index.vue';

export const IvueProgress = withInstall(Progress);
export default IvueProgress;

export * from './index.vue';
